import request from 'tools/request';

export const sendAgentChatMessage = (applicationId, sessionId, message) => {
    return request(
        `applications/${applicationId}/agent-chat`,
        'POST',
        { sessionId, message }
    );
};

export const endAgentChatSession = (applicationId, sessionId) => {
    return request(
        `applications/${applicationId}/agent-chat/end`,
        'POST',
        { sessionId }
    );
};

export const getAgentChatStatus = (applicationId) => {
    return request(
        `applications/${applicationId}/agent-chat/status`,
        'GET'
    );
};

export const getAgentChat = (applicationId, sessionId) => {
    return request(
        `applications/${applicationId}/agent-chat?sessionId=${sessionId}`,
        'GET'
    );
};

export const getClosedChats = (applicationId) => {
    return request(
        `applications/${applicationId}/agent-chat/closed`,
        'GET'
    );
};